import {Component, OnInit} from '@angular/core';
import {StepComponent} from '../../step/step.component';
import {EingabeForm} from './eingabe.form';
import {Step, StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {ElementService} from '../../services/element.service';
import {PortalService} from '../../services/portal.service';
import {ThermostatcheckAnfrage} from "../anfrage/thermostatcheck.anfrage";
import {ThermostatcheckRequestService} from "../services/request.service";

/**
 * Overwrite the Generic step component for the first section of the thermostatcheck.
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-eingabe',
    templateUrl: '../../step/step.component.html',
    standalone: false
})
export class EingabeStepComponent extends StepComponent implements OnInit {

  /**
   * (input) data of the user
   */
  anfrage: ThermostatcheckAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: EingabeForm;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix = 'thermostatcheck';

  /**
   * textkey will be set in case of an error
   */
  formError: string;

  /**
   * Holds the previous step object to move back.
   */
  previousStep: Step;

  /**
   * @inheritDoc
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: ThermostatcheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in this steps and init the parent form
    this.formConfig = new EingabeForm();
    super.ngOnInit();

    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.anfrage = this.anfrage;

    this.formConfig.setStepComponent(this);
    this.formConfig.setData(this.anfrage.userInput);

    // update the previous step
    this.onStepUpdate();

    // go to result page after last input
    if (this.steps?.currentStep && this.steps?.currentStep?.name === 'basisdaten/4') {
      this.steps.nextStep = new Step('ergebnis/analyse', '/thermostatcheck/ergebnis/analyse');
    }
  }

  /**
   * @inheritDoc
   */
  saveData(data: { [key: string]: any }) {
    // merge the data with the existing data
    this.anfrage.userInput = {...this.anfrage.userInput, ...data};
    this.requestService.setAnfrage(this.anfrage);

    // save the data also to the server
    this.requestService.saveDataToServer();

    super.saveData(data);
  }

  /**
   * moveon to the next step in the routing
   */
  moveToNextStep(): void {
    if (this.steps?.currentStep && this.steps?.currentStep?.name === 'basisdaten/4') {
      this.getTecResult();
    }
    else {
      super.moveToNextStep();
    }
  }

  /**
   * Return the next step from a step list
   */
  getNextStepFromList(stepList: Step[]): any {
    return super.getNextStepFromList(stepList);
  }

  /**
   * @inheritDoc
   */
  onSubmit() {
    super.onSubmit();

    if (this.form.valid === false) {
      // form is not valid, maybe form errors are shown. Scroll upwards
      this.elementService.scrollToElement(this.stepForm.nativeElement);
    }

    // end advisor in case of userinput is "raumthermostat"
    if(this.isAdvisorEnd()) {
      this.router.navigateByUrl(this.portalService.currentPortalId + '/thermostatcheck/eingabe/ausstieg', {state: {lastStep: this.router.url}})
    }
  }

  /**
   * get the result from the backend and throw form error if there is no result
   */
  getTecResult(): void {
    this.loading = true;
    //send data to backend
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      // recalculate result
      this.requestService.backendService.result(this.anfrage, requestId).subscribe(data => {
        this.anfrage.result = data;
        this.requestService.setAnfrage(this.anfrage);
        this.loading = false;
        this.router.navigateByUrl(this.portalService.currentPortalId + '/thermostatcheck/ergebnis/analyse');
      }, () => {
        this.formError += '.connection';
        this.loading = false;
      });
    }, () => {
      // an error occured while talking to the backend.
      this.formError += '.connection';
      this.loading = false;
    });
  }

  /**
   * @inheritDoc
   */
  onStepUpdate() {
    super.onStepUpdate();

    // set previous step to intro page
    if (this.steps?.currentStep && this.steps?.currentStep?.name === 'basisdaten/1') {
      this.previousStep = new Step('start', '../../../start');
    }
  }

  /**
   * In case userinput is "raumthermostate" the advisor has to stop because we cannot offer any advice for this user
   */
  isAdvisorEnd(): boolean {
    if(this.steps?.currentStep?.name === 'basisdaten/3' && this.anfrage?.userInput?.thermostatkopftyp === 'raum') {
      return true;
    }
    return false;
  }

}
